import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import * as C from './styles'
import { AppFirebase } from '../../../config/firebase';
import MoviesCarousel from './movies';

export default function Carouselmovies() {

  const [redirectToDetails, setRedirectToDetails] = useState(false);

  const navigate = useNavigate();

  const [ movie, setMovie ] = useState(MoviesCarousel[0]);

  useEffect(() => {
      const mediaQuery = window.matchMedia('(max-width: 800px)');
  
      const handleMediaChange = (e) => {
        if (e.matches) {
          setRedirectToDetails(true)
        } else {
          setRedirectToDetails(false)
        }
      };
  
      // Adiciona o listener de mudanças na mídia
      mediaQuery.addEventListener('change', handleMediaChange);
  
      // Verifica o estado inicial da tela
      if (mediaQuery.matches) {
        handleMediaChange(mediaQuery);
      }
  
      // Remove o listener quando o componente é desmontado
      return () => mediaQuery.removeEventListener('change', handleMediaChange);
  }, []);

  return (
    <C.Container className="carousel-container">
      <C.Content onClick={()=>redirectToDetails ? navigate(`/details/${movie?.media_type}/${movie?.id_tmdb}/${movie?.id_imdb}${!movie?.can_watch_on?.includes('web') ? '?can_watch=false' : ''}`) : null}>
      <div className='background-image-main' style={{backgroundImage: `url(https://image.tmdb.org/t/p/w200/${movie?.background_path})`}}></div>
          <C.ContainerImage>
            <C.Image src={`https://image.tmdb.org/t/p/original/${movie?.background_path}`}/>
            <div className='container-age-rating'>
              <secton className='age-rating'>
                <span className={`span-classificacao-movie-principal span-classificacao-indicativa-${movie?.age_rating}`}>{movie?.age_rating}</span>
              </secton>
            </div>
          </C.ContainerImage>
          <C.Details>
            <div className="div-details">
              <header>
                  <span>{movie?.media_type == 'tv' ? "Série" : "Filme"}</span>
                  <span>{movie?.more_details?.first_air_date ? movie?.more_details?.first_air_date?.slice(0, 4) : movie?.more_details?.release_date?.slice(0, 4)}</span>
                  <span><i className="fas fa-star"></i> {Number(movie?.more_details?.vote_average).toFixed(1) || 5}<small>/10</small></span>
              </header>
              <h1 className="title">{movie?.name}</h1>
              {!movie?.can_watch_on?.includes('web') ?
                <p className='available-on-app'><i className='fas fa-exclamation-triangle'></i> Disponível apenas no app!</p>
                : null
              }
              <p className='overview'>{movie?.overview}</p>
              {!redirectToDetails &&
                <section className='section-bt-watch-movie'>
                    <Link to={`/details/${movie?.media_type}/${movie?.id_tmdb}/${movie?.id_imdb}${!movie?.can_watch_on?.includes('web') ? '?can_watch=false' : ''}`} className='bt-watch-movie'><i className='fas fa-info-circle'></i> <span className='span-assistir-movie-principal'>Detalhes</span></Link>
                    {/*
                    <Link to={`/preview/${movie?.media_type}/${movie?.id}/`} className='bt-watch-movie bt-details-movie'><i className='fas fa-info-circle'></i> <span className='span-assistir-movie-principal'>{idioma == 'ingles' ? 'Details' : 'Detalhes'}</span></Link>
                      */}
                </section>
              }
            </div>
          </C.Details>
        </C.Content>
    </C.Container>
  );
};
